import { FileStatus } from '../files';

export const APPLICATION_SUBMISSION_VALID_FILE_STATUSES: readonly FileStatus[] = [
    FileStatus.AV_SCAN_DONE,
    FileStatus.PROCESSING_DONE
];
